import 'css-chunksrc/client/scenes/task/allocations/allocation/completion/styles.scss';export default {
  "progressBar": "_progressBar_7t1gb_1",
  "textProgressIndicator": "_textProgressIndicator_7t1gb_10"
};